import React, { useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../App.css';
import { ReactComponent as NewLogo } from '../img/cabos-logo.svg'; // Import the SVG as a React component
import { SiteContext } from '../App';

function Navbar({ logout }) {
    const [click, setClick] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { setIsEditMode, isEditMode } = useContext(SiteContext);
    const { exportModelToPDF } = useContext(SiteContext);

    const handleDownloadPDF = () => {
        if (exportModelToPDF) {
            exportModelToPDF();
        } else {
            console.warn("PDF export not available.");
        }
    };

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const handleAddClick = () => {
        navigate('/new-model'); // Navigate to /new-model
    };

    const handleCallTimesClick = () => {
        navigate('/callTimes'); // Navigate to /callTimes
    }

    const handleBillingClick = () => {
        navigate('/billing'); // Navigate to /billing
    }

    const handlePoolClick = () => {
        navigate('/pool-unit'); // Navigate to /pool-unit
    };

    const handleProfileClick = () => {
        navigate('/profile'); // Navigate to /profile
    };

    const handleCastingsClick = () => {
        navigate('/castings'); // Navigate to /castings
    };

    const handleBookingsClick = () => {
        navigate('/bookings'); // Navigate to /bookings
    };

    const handleBookingConfClick = () => {
        navigate('/bookingConfirmationUnit'); // Navigate to /bookings
    };

    // Only show the Navbar if we are not on the login page
    if (location?.pathname === '/login') {
        return null;
    }

    const showButton = /^\/model\/[^/]+$/.test(location?.pathname);

    return (
        <nav className='navbar'>
            <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                <NewLogo style={{ height: 60, width: 'auto' }} /> {/* Using inline SVG */}
            </Link>
            <div className='menu-icon' onClick={handleClick}>
                <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
            {showButton && (
                <>
                    <div>
                        <button className='nav-links' onClick={() => setIsEditMode(prev => !prev)}>
                            {!isEditMode ? 'Edit Model' : 'cancel'}
                        </button>
                    </div>
                    <div>
                        <button className='nav-links' onClick={handleDownloadPDF}>
                            Export PDF
                        </button>
                    </div>
                </>
            )}
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                <li className='nav-item dropdownNav'>
                    <button className='nav-links'>
                        Model Unit ▾
                    </button>
                    <ul className='dropdownNav-menu'>
                        <li><button onClick={handleBookingsClick}>Bookings</button></li>
                        <li><button onClick={handleCastingsClick}>Castings</button></li>
                        <li><button onClick={handlePoolClick}>Model Pools</button></li>
                        <li><button onClick={handleAddClick}>Add a New Model</button></li>
                    </ul>
                </li>
                <li className='nav-item dropdownNav'>
                    <button className='nav-links'>
                        Production ▾
                    </button>
                    <ul className='dropdownNav-menu'>
                        <li><button onClick={handleCallTimesClick}>Call times</button></li>
                        <li><button onClick={handleBillingClick}>Billing</button></li>
                    </ul>
                </li>
                <li className='nav-item dropdownNav'>
                    <button className='nav-links'>
                        Administration ▾
                    </button>
                    <ul className='dropdownNav-menu'>
                        <li><button onClick={handleBookingConfClick}>Booking Confirmation Templates</button></li>
                    </ul>
                </li>
                <li className='nav-item dropdownNav'>
                    <button className='nav-links'>
                        Account ▾
                    </button>
                    <ul className='dropdownNav-menu'>
                        <li><button onClick={handleProfileClick}>Profile</button></li>
                        <li><button onClick={logout}>Logout</button></li>
                    </ul>
                </li>

            </ul>
        </nav>
    );
}

export default Navbar;
